export const STRIPE_LOGO_URL =
  'https://upload.wikimedia.org/wikipedia/commons/b/ba/Stripe_Logo%2C_revised_2016.svg';

export const SUPPORTED_COUNTRIES = [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
] as const;

export const getCountryLabel = (countryCode?: string): string => {
  const countries: Record<string, string> = {
    US: 'United States',
    CA: 'Canada',
  };
  return countryCode ? countries[countryCode] || countryCode : 'Unknown';
};
